module.exports = __webpack_public_path__ + "fonts/gothica1-bold-webfont.0ac95fa.woff2";